import { Box, RadioGroup, Skeleton, Text, VStack } from '@chakra-ui/react';

import isNil from 'lodash/isNil';

import { FilterRadioGroupProps } from '@app/components/molecules/filter-radio-group';
import { useSearchFilterCounter } from '@app/hooks/useSearchFilterCounter';

export const FilterRadioGroup = ({
    title,
    items,
    selectedValue,
    onValueChange,
    getPredictedValue,
    filterKey,
    isLoading = false,
    withCounter,
}: FilterRadioGroupProps) => {
    const { counters } = useSearchFilterCounter({
        items,
        filterKey,
        selectedValue: selectedValue ?? '',
        getPredictedValue,
        isEnabled: withCounter,
    });

    return (
        <Box>
            {title ? (
                <Skeleton loading={isLoading} w={'160px'} asChild>
                    <Text fontWeight="bold" mb={4}>
                        {title}
                    </Text>
                </Skeleton>
            ) : null}
            <Skeleton loading={isLoading} asChild>
                <RadioGroup.Root
                    value={selectedValue}
                    onValueChange={({ value }) => onValueChange(value ?? '')}
                >
                    <VStack align="stretch" gap={4}>
                        {items.map(({ label, value }, index) => {
                            const isDisabled =
                                selectedValue !== value &&
                                typeof counters[index] === 'number' &&
                                counters[index] === 0;

                            return (
                                <RadioGroup.Item
                                    key={value}
                                    value={value}
                                    gap={4}
                                    cursor={isDisabled ? undefined : 'pointer'}
                                    disabled={isDisabled}
                                >
                                    <RadioGroup.ItemHiddenInput />
                                    <RadioGroup.ItemIndicator />
                                    <RadioGroup.ItemText fontSize="md">
                                        {label}{' '}
                                        {isNil(counters[index]) ? (
                                            ''
                                        ) : (
                                            <Text
                                                as={'span'}
                                                color={'gray.500'}
                                            >{`(${counters[index]})`}</Text>
                                        )}
                                    </RadioGroup.ItemText>
                                </RadioGroup.Item>
                            );
                        })}
                    </VStack>
                </RadioGroup.Root>
            </Skeleton>
        </Box>
    );
};
